/**
 * Massager clinic-location filter API service.
 * Endpoint: GET /api/v1/massager/{site_type}/clinic-locations
 *
 * Site-scoped (no clinic_number in URL): the clinic is resolved server-side
 * from the authenticated massager. Avoids URL-encoding pitfalls when
 * clinic_number contains spaces or other URL-unsafe characters.
 */
import { apiClient } from '@/shared/lib/axios';
import { massagerAuthPath } from '@/shared/lib/apiPath';
import type { MassagerClinicLocationListResponse } from '@/types/massager/clinicLocation';

export interface ListMassagerClinicLocationsParams {
  /** YYYY-MM-DD — date the massager must be active on */
  date: string;
  /** A2 / R2 — the currently active service. null = no service filter. */
  serviceType?: 'A2' | 'R2' | null;
}

export async function listMassagerClinicLocations(
  siteType: string,
  { date, serviceType }: ListMassagerClinicLocationsParams
): Promise<MassagerClinicLocationListResponse> {
  const params: Record<string, string> = { date };
  if (serviceType) params.service_type = serviceType;

  const response = await apiClient.get<MassagerClinicLocationListResponse>(
    massagerAuthPath(siteType, '/clinic-locations'),
    { params }
  );
  return response.data;
}
